import softwareSchemas from "./software-schemas.json";

const normalizePath = (url) => {
    if (!url || typeof url !== "string") return null;

    try {
        const parsedUrl = new URL(url, process.env.GATSBY_SITE_URL);
        return parsedUrl.pathname.replace(/\/$/, "") || "/";
    } catch {
        return url.replace(/\/$/, "") || "/";
    }
};

const softwareSchemasByPath = Object.entries(softwareSchemas).reduce(
    (schemasByPath, [path, schema]) => {
        const normalizedPath = normalizePath(path);

        if (normalizedPath && schema) {
            schemasByPath[normalizedPath] = schema;
        }

        return schemasByPath;
    },
    {}
);

const getSoftwareSchemaForPost = (post, pathname) => {
    const pagePath = normalizePath(pathname);
    const canonicalPath = normalizePath(post?.seo?.canonical);
    const uriPath = normalizePath(post?.uri);

    return (
        softwareSchemasByPath[pagePath] ||
        softwareSchemasByPath[canonicalPath] ||
        softwareSchemasByPath[uriPath] ||
        null
    );
};

export { getSoftwareSchemaForPost };
